import Axios from "axios";
import { useEffect, useReducer } from "react";
import { dataFetchReducer, parseTournamentEvents } from "./data";
import { getConfiguration, getLocaleTimestamp, getDBTimestampFromDate, groupEventsByDate, filterByCustomizedState } from "./utils";
import { systemCode, xs_languageCode } from '..';
import { parseMacroGruppi } from "./parseMacroGruppi";
import { parseOutrightsData } from "./parseOutrightsData";

function parseResponse(data, tournamentData, tournamentId) {
    const conf = getConfiguration();
    // Filter expired events
    let events = tournamentData.avs.filter(avv => {
        const matchTimestamp = conf.dbutc ? getLocaleTimestamp(avv.ts) : avv.ts;
        const currentTimestamp = getDBTimestampFromDate(new Date());
        return matchTimestamp.localeCompare(currentTimestamp) > 0;
    });
    events = filterByCustomizedState(events);
    const tournament = {
        // Recupera i dati del torneo
        ...data.tournamentByUniqueId[tournamentId],
        // Aggiungi gli eventi al torneo
        events
    };
    //const aggregate = tournamentData.ags;
    tournament.events = parseTournamentEvents(data, tournament, [], 0, false, false);

    // Aggiungi i macrogruppi, se esistono
    tournament.macrogruppi = tournament.events.length > 0 ? parseMacroGruppi(tournament.events[0].gruppoById, tournament.sportRef, false) : [];
    //Aggiungo classifica
    tournament.classifica = tournamentData.sid;
    tournament.outrights = tournamentData.ors ? parseOutrightsData(tournamentData.ors, tournament.sportRef,tournament.descrizione,data.sportById[tournament.sportRef].descrizione) : [];
	tournament.betbuilder = tournamentData.bb;
    [tournament.dates, tournament.matchesByDate] = groupEventsByDate(tournament.events);

    return tournament;
}


export function useFetchBetBuilderEvents(data, tournament, shouldExecute, reload) {
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });
    
    useEffect(() => {
        if (!shouldExecute) {
            return;
        }
        
        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await Axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };

        const url = getConfiguration().api.getBetBuilderEvents;
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            sportId: tournament.sportRef,
            categoryId: tournament.categoryRef,
            tournamentId: tournament.id
        }
        fetchData(url, params, function(response) {
            if (response == null || response === '') {
                dispatch({ type: 'FETCH_FAILURE' });
            }
            const betBuilderEvents = parseResponse(data, response, tournament.uniqueId);
            dispatch({ type: 'FETCH_SUCCESS', payload: betBuilderEvents });
        });
        
        return () => {
            didCancel = true;
        };
    }, [data, tournament, shouldExecute, reload]);

    return [state, dispatch];
}